/**
 * DataModeBadge — shows whether an org runs on modeled benchmarks, its own
 * measured data, or a mix. A lightweight customer-success signal for
 * prioritizing data-onboarding outreach.
 */
import React from 'react';
import { Sparkles, CheckCircle2, GitMerge } from 'lucide-react';
import { Badge } from '../ui/badge';

const MODES = {
  modeled: { label: 'Modeled', cls: 'bg-cyan-50 text-cyan-700 border-cyan-200', Icon: Sparkles },
  mixed: { label: 'Mixed', cls: 'bg-amber-50 text-amber-700 border-amber-200', Icon: GitMerge },
  measured: { label: 'Measured', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200', Icon: CheckCircle2 },
};

export default function DataModeBadge({ mode, testId }) {
  const m = MODES[mode];
  if (!m) return null;
  const { label, cls, Icon } = m;
  return (
    <Badge variant="outline" className={`text-xs font-medium gap-1 ${cls}`} data-testid={testId} title={`Data mode: ${label}`}>
      <Icon className="h-3 w-3" /> {label}
    </Badge>
  );
}
